import { useQueryClient } from '@tanstack/react-query';

import { queryIds } from '@/shared/utils/constants';
import { trpc } from '@/config/trpc';
import useHandleSaveContactError from '@/shared/hooks/useHandleSaveContactError';

const useCreateContact = () => {
  const queryClient = useQueryClient();
  const utils = trpc.useUtils();
  const handleSaveContactError = useHandleSaveContactError();

  return trpc.contact.create.useMutation({
    onError: handleSaveContactError,
    onSuccess: () => {
      utils.contact.list.invalidate();
      utils.contact.pagedList.invalidate();
      queryClient.invalidateQueries([queryIds.contacts.GET_CONTACTS]);
      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey[0] === queryIds.crm.GET_OPTIONS,
      });
    },
  });
};

export default useCreateContact;
